import React, { useEffect, useState } from 'react';
import IVSPlayerContext from './services/ivsPlayerContext';
import Routes from './routes/Routes';
import { BrowserRouter } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import useWindowDimensions from './theme/useWindowDimensions';
import Box from '@material-ui/core/Box';

function App() {
  const { height } = useWindowDimensions();
  const [IVSPlayer, setIVSPlayer] = useState(null);
  const [IVSInstance, setIVSInstance] = useState(null);
  //1.1.7.2 Final release
  useEffect(() => {
    setIVSPlayer(window.IVSPlayer);
  }, []);

  useEffect(() => {
    if (IVSPlayer) {
      setIVSInstance(IVSPlayer.create());
    }
    return () => {
      //'deleting player instance'
      IVSInstance?.delete();
    };
  }, [IVSPlayer]);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Box
          width={1}
          height={1}
          component="div"
          style={{
            height: height - 0.1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <IVSPlayerContext.Provider
            value={{
              IVSPlayer: IVSPlayer,
              IVSInstance: IVSInstance,
            }}
          >
            <Routes />
          </IVSPlayerContext.Provider>
        </Box>
      </MuiPickersUtilsProvider>
    </BrowserRouter>
  );
}

export default App;
